<div *transloco="let t" class=" grid-item">
  <div [ngClass]="isXsScreen ? '' : 'p-10'" [class.zoom-wrapper]="zoomEffect">
    <div class="event-card position-relative d-flex justify-content-between flex-column position-relative"
         [class.zoom-target]="zoomEffect" [ngClass]="{'clickable': isSmallerThanXl}" (click)="handleCardClick()">
      <div class="d-flex favorite-event-indicator">
        <app-favorite-event-indicator [eventItem]="eventItem" [isXsComponent]="true"/>
      </div>
      <div>
        <div class="image-wrapper" [class.finished]="isFinishedEvent">
            @if (eventItem?.sportOne || eventItem?.sportTwo) {
              <div class="race-sport-wrapper">
                <p class="medium italic text-uppercase">
                  @if (eventItem?.sportOne) {
                    {{t("app.common.sports." + eventItem?.sportOne)}}
                  } @else if (eventItem?.sportTwo) {
                    {{t("app.common.sports." + eventItem?.sportTwo)}}
                  }
                </p>
              </div>
            }
            <img src="{{eventItem?.imageMedium || ''}}" alt="Sport Image" class="bck-img"
                 [sportOne]="eventItem?.sportOne" [sportTwo]="eventItem?.sportTwo" appImageFallback>
        </div>
        <div class="d-flex flex-column pt-3 pe-3 ps-3 line-height-1">
          @if (isFinishedEvent) {
            <div class="pb-1 d-flex">
              <app-badge-alt text="{{ t('event.item.status.2') }}" iconSrc="assets/icons/icons-alt/checkmark-circle.svg"
                             backgroundColor="#E5F6FD"></app-badge-alt>
            </div>
          }
          <p class>
            <app-event-date-display [eventItem]="eventItem"/>
          </p>
          <p class="fs-18 trim-text-second-line my-2 title-wrap">
            <app-language-output [hrLabel]="eventItem?.name" [srLabel]="eventItem?.nameSr"
                                 [enLabel]="eventItem?.nameEng" [itLabel]="eventItem?.nameIta"
                                 [bsLabel]="eventItem?.nameBs" [siLabel]="eventItem?.nameSlo"
                                 [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages"/>
          </p>
          <div class="d-flex flex-row align-items-center">
          <span class="pe-1 pb-2">
            <img src="assets/icons/icons-alt/location-alt.svg" alt="Location" class="card-body__icon"/>
          </span>

            <p class="regular d-inline-flex">
            <span *ngIf="eventItem?.city; else dash">
            {{eventItem?.city}}
          </span>

              <span *ngIf="eventItem?.country">
              {{','}}
            </span>

              <span *ngIf="eventCountry?.shortCode">
              <span class="ps-1">{{eventCountry?.shortCode}}</span>
            </span>

              <ng-template #dash>
                <span>-</span>
              </ng-template>
            </p>

          </div>
          <div class="d-flex flex-row align-items-center">
            <span class="pe-1" style="flex-shrink: 0;">
              <img src="assets/icons/icons-alt/route-alt.svg" alt="Running" class="card-body__icon"/>
            </span>
            <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-width: 0;"
                 class="flex-grow-1">
              @for (length of lengths;track length;let idx = $index) {
                {{length | raceLengthFormat: translocoService.getActiveLang()}}
                @if (idx < lengths.length - 1) {
                  <span class="race-length-wrapper__separator">&nbsp;|&nbsp;</span>
                }
              }
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end pb-3 pe-3" [ngClass]="isSmallerThanXl ? 'ps-3' : ''">
        <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'" [buttonHeight]="'44px'"
                        [text]="t('app.common.viewdetails')|uppercase" [borderColor]="'var(--teal-500)'"
                        (onClickCallback)="onRightButtonClick()" [isFullWidth]="isSmallerThanXl"></app-button-alt>
      </div>
    </div>
  </div>
</div>
